import Button from "@mui/material/Button"
import { Grid2 as Grid, MenuItem } from "@mui/material"
import { Formik, Field } from "formik"
import { Formato } from "../../types"
import { useMemo } from "react"
import * as yup from "yup"
import { transformErrorForForm } from "../../utils/utils"
import { FormikSelect, FormikTextField } from "./formsHelpers"
import { FormInDialogEditProps } from "../DialogForm"
import { useTranslation } from "react-i18next"

export default function FormatoForm({ item, save, ref }: FormInDialogEditProps<Formato>) {
  const { t } = useTranslation()

  const schema = useMemo(
    () =>
      yup.object().shape({
        nome: yup.string().required(t("validation.required")),
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={
        item || {
          nome: "",
          unita_misura: "metri",
          frames_metro: "",
          segnatura: "",
          note: "",
        }
      }
      enableReinitialize
      onSubmit={(values, formikBag) => {
        const newValues = { ...values }
        if (values.unita_misura !== "metri") {
          newValues.frames_metro = undefined
        }
        return save(newValues as Formato).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            {/* <FormatoFormManager/> */}

            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={6}>
                <Field
                  component={FormikTextField}
                  name="nome"
                  label={t("formato.nome")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              <Grid size={6}>
                <Field
                  component={FormikSelect}
                  name="unita_misura"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  required
                  label={t("formato.unita_misura")}
                >
                  <MenuItem value={"metri"}>{t("formato.enum_unita_misura.metri")}</MenuItem>
                  <MenuItem value={"minuti"}>{t("formato.enum_unita_misura.minuti")}</MenuItem>
                </Field>
              </Grid>

              <Grid size={6}>
                <Field
                  component={FormikTextField}
                  name="segnatura"
                  label={t("formato.segnatura")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              <Grid size={6}>
                <Field
                  component={FormikTextField}
                  name="frames_metro"
                  label={t("formato.frames_metro")}
                  type="number"
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  disabled={values.unita_misura !== "metri"}
                  helperText={values.unita_misura !== "metri" ? t("formato.frames_metro_helper") : ""}
                />
              </Grid>

              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="note"
                  label={t("formato.note")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  multiline
                  minRows={6}
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
